import { createClient } from "@supabase/supabase-js";
import { Config } from "../../../Config";

export const supabase = createClient(Config.SUPABASE_URL, Config.SUPABASE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export const getSupabaseAuthToken = async () => {
  const session = await supabase.auth.getSession();

  return session?.data.session?.access_token;
};

export const clearSupabaseAuthToken = async () => {
  await supabase.auth.signOut();
};
